var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeftIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812326 8.23959L6.70816 14.125C6.805 14.2226 6.9202 14.3001 7.04714 14.353C7.17408 14.4059 7.31023 14.4331 7.44774 14.4331C7.58525 14.4331 7.72141 14.4059 7.84834 14.353C7.97528 14.3001 8.09049 14.2226 8.18733 14.125C8.38134 13.9298 8.49023 13.6658 8.49023 13.3906C8.49023 13.1154 8.38134 12.8514 8.18733 12.6563L3.03108 7.44793L8.18733 2.29168C8.38134 2.09651 8.49024 1.8325 8.49024 1.5573C8.49024 1.28211 8.38134 1.0181 8.18733 0.822927C8.09085 0.724503 7.97581 0.646199 7.84885 0.592557C7.7219 0.538915 7.58556 0.511001 7.44774 0.510428C7.30992 0.511001 7.17359 0.538915 7.04663 0.592557C6.91968 0.646199 6.80463 0.724502 6.70816 0.822927L0.812327 6.70834C0.706592 6.80589 0.622208 6.92427 0.564492 7.05605C0.506776 7.18782 0.47698 7.33011 0.47698 7.47397C0.47698 7.61783 0.506776 7.76012 0.564492 7.89189C0.622208 8.02366 0.706592 8.14205 0.812326 8.23959Z",
    fill: "#266071"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftIconBlue);
export default __webpack_public_path__ + "static/media/chevron_left_icon_blue.0ec265167dc641d5a2f193c20946e99a.svg";
export { ForwardRef as ReactComponent };